import { render, staticRenderFns } from "./FaqList.vue?vue&type=template&id=4d80bbfe&scoped=true&"
import script from "./FaqList.vue?vue&type=script&lang=ts&"
export * from "./FaqList.vue?vue&type=script&lang=ts&"
import style0 from "./FaqList.vue?vue&type=style&index=0&id=4d80bbfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d80bbfe",
  null
  
)

export default component.exports